var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconBenefitRiskManagement1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 10,
    viewBox: "0 0 21 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4234 9.99072H1.37541C1.3129 9.99072 1.25101 9.97841 1.19326 9.95449C1.13551 9.93057 1.08303 9.89551 1.03883 9.85131C0.994631 9.8071 0.959569 9.75463 0.935647 9.69688C0.911726 9.63913 0.899414 9.57723 0.899414 9.51472C0.899414 6.9888 1.90283 4.56633 3.68893 2.78024C5.47503 0.994141 7.89749 -0.00927734 10.4234 -0.00927734H11.3754C12.6261 -0.00927734 13.8646 0.237068 15.0201 0.715694C16.1756 1.19432 17.2255 1.89585 18.1099 2.78024C18.9943 3.66462 19.6958 4.71454 20.1744 5.87005C20.6531 7.02555 20.8994 8.26401 20.8994 9.51472C20.8994 9.57723 20.8871 9.63913 20.8632 9.69688C20.8393 9.75463 20.8042 9.8071 20.76 9.85131C20.7158 9.89551 20.6633 9.93057 20.6056 9.95449C20.5478 9.97841 20.4859 9.99072 20.4234 9.99072Z",
    fill: "url(#paint0_linear_3443_12538)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4234 9.99072H1.37541C1.3129 9.99072 1.25101 9.97841 1.19326 9.95449C1.13551 9.93057 1.08303 9.89551 1.03883 9.85131C0.994631 9.8071 0.959569 9.75463 0.935647 9.69688C0.911726 9.63913 0.899414 9.57723 0.899414 9.51472C0.899414 6.9888 1.90283 4.56633 3.68893 2.78024C5.47503 0.994141 7.89749 -0.00927734 10.4234 -0.00927734H11.3754C12.6261 -0.00927734 13.8646 0.237068 15.0201 0.715694C16.1756 1.19432 17.2255 1.89585 18.1099 2.78024C18.9943 3.66462 19.6958 4.71454 20.1744 5.87005C20.6531 7.02555 20.8994 8.26401 20.8994 9.51472C20.8994 9.57723 20.8871 9.63913 20.8632 9.69688C20.8393 9.75463 20.8042 9.8071 20.76 9.85131C20.7158 9.89551 20.6633 9.93057 20.6056 9.95449C20.5478 9.97841 20.4859 9.99072 20.4234 9.99072Z",
    fill: "white",
    fillOpacity: 0.17
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3443_12538",
    x1: 20.8994,
    y1: -0.00927869,
    x2: 0.0975476,
    y2: 2.28841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFA600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.234764,
    stopColor: "#FF9407"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.538685,
    stopColor: "#FF7D11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.799781,
    stopColor: "#FF6A19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF5B1F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBenefitRiskManagement1);
export default __webpack_public_path__ + "static/media/icon-benefit--risk-management1.239cc9f63317d9f512b44ecf7fb22c4a.svg";
export { ForwardRef as ReactComponent };